import React from 'react';
import SidebarProfile from './SideBarProfile';
import EditUserProfile from '../../components/user-profile/edit-profile';
import TopSection from '../../components/TopSection';

export default function UserProfile() {
  return (
    <>
      <TopSection heading="Edit profile" />
      <div className="main_container about-us about-top">
        <div className="container">
          <EditUserProfile
            ui="/profile"
            epr="/profile"
            edpr="/profile-edit-user"
            epic="/main-edit-user-profile-picture"
            elog="/main-edit-user-company-logo"
          >
            <SidebarProfile />
          </EditUserProfile>
        </div>
      </div>
    </>
  );
}
